import { Icons } from '@/components/Shares/Icons';
import { Flex, Grid, Tabs, Text } from '@mantine/core';
export type AccountTabItemProps = {
  iconName: string;
  itemName: string;
  value: string;
  handleClick?: () => void;
};
export const AccountTabItem: React.FC<AccountTabItemProps> = ({
  iconName,
  itemName,
  value,
  handleClick
}) => {
  return <Grid.Col span={3}>
      <Tabs.Tab value={value} w={{
      base: 85,
      sm: 158
    }} h={{
      base: 74,
      sm: 46
    }} onClick={() => handleClick?.()}>
        <Flex direction={{
        base: 'column',
        sm: 'row'
      }} justify="center" align="center" gap={8}>
          <Icons className={iconName} fontSize={24} />
          <Text fz={{
          base: 10,
          sm: 12
        }} c="inherit" ta="center" fw={700}>
            {itemName}
          </Text>
        </Flex>
      </Tabs.Tab>
    </Grid.Col>;
};